import React from 'react'

const Footer = () => {
    return (
        <footer>
            <hr className="line"/>
            <div className="max-container footer_comp">
                    <p>info[@]pilvon.ee</p>
            </div>
        </footer>
    )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx